import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface ICopyBlocksMutationParameters {
    srcProductId: string;
    srcVariantId: string;
    targetProductId: string;
    targetVariantId: string;
}

export const useCopyBlocks = (
    invalidQueryKeys: string | string[],
): UseMutationResult<{ blocks: number }, unknown, ICopyBlocksMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<{ blocks: number }, unknown, ICopyBlocksMutationParameters>({
        mutationFn: async (parameters: ICopyBlocksMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot copy blocks without authorization token.");
            }

            return await api.Products.copyBlocks(
                parameters.srcProductId,
                parameters.srcVariantId,
                parameters.targetProductId,
                parameters.targetVariantId,
                auth.token
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
